import TiersContent from "./TiersContent";

export default TiersContent;